import styleConfig from '../../../theme/config';

const styles = {
  box: { display: 'flex' },
  loader: { color: styleConfig.colors.secondary },
};

export default styles;
